export class InternalIndex {
    Name: string;
    Key: string;
    IsUnique: boolean;
    MultiEntry?: boolean;

    // tslint:disable-next-line: bool-param-default
    constructor(name: string, key: string, isUnique: boolean, multiEntry?: boolean) {
        this.Name = name;
        this.Key = key;
        this.IsUnique = isUnique;
        this.MultiEntry = multiEntry;
    }

    getIDBIndexParameters(): IDBIndexParameters {
        return {
            multiEntry: this.MultiEntry,
            unique: this.IsUnique
        };
    }
}